import { Body, Controller, Get, Post } from '@nestjs/common';
import { ContainerService } from './container.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ContainerDTO } from './dto/container.dto';
import { AllBlStatusInfo, AllContainerStatusInfo, BillNoUpdateRequest, BookingContainerResponse, ConfirmOrAssignSoResponse, ContainerDetailsResponse, ContainerDispatchedToPlantResponse, ContainerResponse, EtdUpdateRequest, FillSealInfoResponse,ContaierRegisterRequest, AllLoadingReportResponse, ShipmentDetailsDto, ShippmentDetailsResponse, ContainerReportResponse, ContainerBarChartResponseModel, Containertrnd, ContainerStatusRequest, GrossMassResponseModel, componentRequest } from '@gtpl/shared-models/logistics';

import { ApiBody, ApiTags } from '@nestjs/swagger';
import { BookContainerDto } from './dto/book-container.dto';
import { DispatchedToPlant } from './dto/container-dispatched-to-plant.dto';
import { ContainerStatusInfo } from './dto/containers-status-info';
import { DraftReceived } from './dto/draft-received.dto';
import { PlantInvoiceDetailsRequest } from '@gtpl/shared-models/sale-management';
import { ContainerSoIdRequest } from './dto/container-soId.request';
import { AuthorisedRequest, ContainerIdRequest, SaleOrderIdRequestLc } from './dto/container-id.request';
import { UnitRequest } from './dto/unit.id.request';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { ContainerYearRequest } from './dto/container-year-request';
import { LoadingSheetReqDto } from './loading-sheet-req-dto';
import { LoadingSheetSaleOrderReq } from '@gtpl/shared-models/common-models';
import { FreightAfterShipmentDto } from './dto/freight-after-shipment.dto';
import { PostShipmentDetailsDto } from './dto/post-shipment-details-dto';

import { ExpensesLogisticsDto } from './dto/expenses-logistics-dto';
import { SaleOrderIdRequest, SaleOrderIdRequest as saleOrderIdRequest } from 'libs/shared-models/logistics/src/lib/container-register/container.request';
import { BlContainerDischargeReq } from './dto/bl-container-discharege-dto';
import { DailySheetData } from './dto/daily-sheet-date.req';

@ApiTags('container')
@Controller('container')
export class ContainerController {
    constructor(private service: ContainerService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }
    // containerServices: any;

    // @Post('/CreateContainer')
    // async CreateContainer(@Body() containerData: ContainerDTO):Promise<ContainerResponseModel>{
    //     try{
    //         return this.containerServices.CreateContainer(containerData, false);
    //     }catch(error){
    //         return error;
    //     }
    // }


    // get All Container Status Info
    @Post('getAllContainerStatusInfo')
    async getAllContainerStatusInfo(@Body() req: UnitRequest): Promise<AllContainerStatusInfo> {
        // console.log(containerRegisterRequest);
        try {
            return this.service.getAllContainerStatus(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllContainerStatusInfo, error);
        }
    }


    @Post('getDocumentsFilePaths')
    async getDocumentsFilePaths(): Promise<AllContainerStatusInfo> {
        try {
            return this.service.getDocumentsFilePaths();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllContainerStatusInfo, error);
        }
    }

    // To bookContainer
    @Post('bookContainer')
    async bookContainer(@Body() containerInfo: BookContainerDto): Promise<BookingContainerResponse> {
        try {
            return this.service.bookContainer(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BookingContainerResponse, error);
        }
    }

    @Post('checklist')
    async checklist(@Body() containerInfo: BookContainerDto): Promise<BookingContainerResponse> {
        try {
            return this.service.checklist(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BookingContainerResponse, error);
        }
    }

    @Post('postShipmentDetails')
    async postShipmentDetails(@Body() containerInfo: BookContainerDto): Promise<BookingContainerResponse> {
        try {
            return this.service.postShipmentDetails(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BookingContainerResponse, error);
        }
    }
    // To containerDispatchedToPlant
    @Post('containerDispatchedToPlant')
    async containerDispatchedToPlant(@Body() containerInfo: DispatchedToPlant): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.containerDispatchedToPlant(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To confirmOrAssignSo
    @Post('confirmOrAssignSo')
    async confirmOrAssignSo(@Body() containerInfo: DispatchedToPlant): Promise<ConfirmOrAssignSoResponse> {
        try {
            return this.service.confirmOrAssignSo(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ConfirmOrAssignSoResponse, error);
        }
    }

    // To fill seal info
    @Post('fillSealInfo')
    async fillSealInfo(@Body() containerInfo: ContainerDTO): Promise<FillSealInfoResponse> {
        try {
            return this.service.fillSealInfo(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FillSealInfoResponse, error);
        }
    }

    // To Update the status to ReadyToBook
    @Post('updateToReadyToBook')
    async updateToReadyToBook(@Body() containerInfo: DispatchedToPlant): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.updateToReadyToBook(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To Update the status to Booked
    @Post('updateToBooked')
    async updateToBooked(@Body() containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.updateToBooked(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }
    @Post('updateStatusToLoading')
    async updateStatusToLoading(@Body() containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.updateStatusToLoading(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To Update the status to DispatchedToPlant
    @Post('updateToDispatchedToPlant')
    async updateToDispatchedToPlant(@Body() containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.updateToDispatchedToPlant(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To Update the status to Loading
    @Post('updateToLoading')
    async updateToLoading(@Body() containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.updateToLoading(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To Update the status to LoadedAndSealed
    @Post('updateToLoadedAndSealed')
    async updateToLoadedAndSealed(@Body() containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.updateToLoadedAndSealed(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To initiate dispatch
    @Post('initiateDispatch')
    async initiateDispatch(@Body() containerInfo: ContainerStatusInfo) {
        try {
            return this.service.initiateDispatch(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To Ship the container
    @Post('shipContainer')
    async shipContainer(@Body() containerInfo: ContainerStatusInfo): Promise<ContainerResponse> {
        try {
            return this.service.shipContainer(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerResponse, error);
        }
    }


    // ---------------- BL status services ------------------

    @Post('getAllContainerBlStatusInfo')
    async getAllContainerBlStatusInfo(@Body()req: UnitRequest): Promise<AllBlStatusInfo> {
        try {
            return this.service.getAllContainerBlStatusInfo(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllBlStatusInfo, error);
        }
    }

    @Post('notReceived')
    async notReceived(@Body() containerInfo: DraftReceived) {
        try {
            return this.service.notReceived(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    @Post('draftReceived')
    async draftReceived(@Body() containerInfo: DraftReceived) {
        try {
            return this.service.draftReceived(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    @Post('oblReceived')
    async oblReceived(@Body() containerInfo: DraftReceived) {
        try {
            return this.service.oblReceived(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    @Post('receivedAndShared')
    async receivedAndShared(@Body() containerInfo: DraftReceived) {
        try {
            return this.service.receivedAndShared(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }
    @Post('updateEtd')
    async updateEtd(@Body() containerInfo: EtdUpdateRequest) {
        // console.log(containerInfo);
        try {
            return this.service.updateEtd(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }
    @Post('updateBlNo')
    async updateBlNo(@Body() containerInfo: BillNoUpdateRequest) {
        // console.log(containerInfo);
        try {
            return this.service.updateBlNo(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }
    @Post('updateShipmentDetails')
    async updateShipmentDetails(@Body() req: ShipmentDetailsDto): Promise<ContainerDetailsResponse> {
        try {
            return this.service.updateShipmentDetails(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDetailsResponse, error);
        }
    }
    @Post('getShipmentDetails')
    async getShipmentDetails(@Body() req: ContainerIdRequest): Promise<ShippmentDetailsResponse> {
        try {
            return this.service.getShipmentDetails(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ShippmentDetailsResponse, error);
        }
    }


    /**
     * To get containerNumber,lineSeal,Eseal
     * @Param saleOrderId
     */
    @Post('/getContainerDeatils')
    async getContainerDeatils(@Body() soId: ContainerSoIdRequest): Promise<ContainerDetailsResponse> {
        try {
            return await this.service.getContainerDeatils(soId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDetailsResponse, error);
        }
    }

    @Post('/getLoadingReportDetails')
    async getLoadingReportDetails(): Promise<AllLoadingReportResponse> {
        try {
            return await this.service.getLoadingReportDetails();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllLoadingReportResponse, error);
        }
    }
    
    @Post('/getContainerReportData')
    async getContainerReportData(): Promise<ContainerReportResponse> {
        try{
            return await this.service.getContainerReportData();
        }catch(error){
            return this.applicationExceptionHandler.returnException(ContainerReportResponse, error);
        }
    }
    @Post('/getMonthWiseContainersData')
    async getMonthWiseContainersData(@Body()req:ContainerYearRequest): Promise<ContainerBarChartResponseModel> {
        try{
            return await this.service.getMonthWiseContainersData(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ContainerBarChartResponseModel, error);
        }
    }

    @Post('/getTopFiveDestinations')
    async getTopFiveDestinations(): Promise<CommonResponse>{
        try{
            return await this.service.getTopFiveDestinations();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getLogisticsLifeCycleData')
    async getLogisticsLifeCycleData(): Promise<CommonResponse>{
        try{
            return await this.service.getLogisticsLifeCycleData();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
@Post('/gettotalsaleorderShipped')
async gettotalsaleorderShipped(@Body()req:ContainerYearRequest):Promise<CommonResponse>{
    try{
        return await this.service.gettotalsaleorderShipped(req);
    }catch(error){
        return this.applicationExceptionHandler.returnException(CommonResponse,error);
    }
}
@Post('/totalsaleordersshiipedinyear')
async totalsaleordersshiipedinyear(@Body()req:ContainerYearRequest):Promise<CommonResponse>{
    try{
        return await this.service.totalsaleordersshiipedinyear(req);
    }catch(error){
        return this.applicationExceptionHandler.returnException(CommonResponse,error);
    }
}
@Post('/totalsaleordersShippedinDayWise')
async totalsaleordersShippedinDayWise(@Body()req:ContainerYearRequest):Promise<CommonResponse>{
    try{
        return await this.service.totalsaleordersShippedinDayWise(req);
    }catch(error){
        return this.applicationExceptionHandler.returnException(CommonResponse,error);
    }
}

@Post('/getLogisticsDailyUsage')
async getLogisticsDailyUsage():Promise<CommonResponse>{
    try{
        return await this.service.getLogisticsDailyUsage();
    }catch(error){
        // console.log(error)
        return this.applicationExceptionHandler.returnException(CommonResponse,error);
    }
}

@Post('/getSoIdsByStatus')
async getSoIdsByStatus(soId:ContainerStatusRequest): Promise<CommonResponse>{
    try{
        return await this.service.getSoIdsByStatus(soId);
    }catch(error){
        // console.log(error)
        return this.applicationExceptionHandler.returnException(CommonResponse,error);
    }
}

@Post('/createLoadingSheet')
// @ApiBody({type:LoadingSheetReqDto})
async createLoadingSheet(@Body() req: LoadingSheetReqDto): Promise<CommonResponse> {   
//   console.log(req,"reqqqqqqqqqqqq");
   
    try {
        return this.service.createLoadingSheet(req)
    }
    catch (err) {
        return this.applicationExceptionHandler.returnException(CommonResponse, err)
    }
}

@Post('/getLoadingSheetDescriptionDetails')
async getLoadingSheetDescriptionDetails(@Body() req:LoadingSheetSaleOrderReq): Promise<CommonResponse> {
  try {
    return await this.service.getLoadingSheetDescriptionDetails(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}


@Post('documentApprovelOpenShipment')
async documentApprovelOpenShipment(@Body() containerInfo: FreightAfterShipmentDto): Promise<CommonResponse> {
    try {
        return this.service.documentApprovelOpenShipment(containerInfo);
    } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
}

@Post('getDailySheetData')
async getDailySheetData(): Promise<CommonResponse> {
    try {
        return this.service.getDailySheetData();
    } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
}

@Post('getDailySheetData1')
async getDailySheetData1(@Body() req:DailySheetData): Promise<CommonResponse> {
    try {
        return this.service.getDailySheetData1(req);
    } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
}

@Post('/getLoadingSheetPrintDetails')
async getLoadingSheetPrintDetails(@Body() req:LoadingSheetSaleOrderReq): Promise<CommonResponse> {
  try {
    return await this.service.getLoadingSheetPrintDetails(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getVarietyForLoadingSheet')
async getVarietyForLoadingSheet(@Body() req:LoadingSheetSaleOrderReq): Promise<CommonResponse> {
  try {
    return await this.service.getVarietyForLoadingSheet(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}

@Post('/getLotNumbersForLoadingPrint')
async getLotNumbersForLoadingPrint(@Body() req:LoadingSheetSaleOrderReq): Promise<CommonResponse>{
  
    
   try{
    return this.service.getLotNumbersForLoadingPrint(req);
   } catch(err){
    return this.applicationExceptionHandler.returnException(CommonResponse,err);
   }
}

@Post('/getGrossMassOfContainerPrintData')
async getGrossMassOfContainerPrintData(@Body() req:LoadingSheetSaleOrderReq): Promise<GrossMassResponseModel>{
    // console.log(req,"controoooooleeeerrrrrreqqqqqqqqq");
   try{
    return this.service.getGrossMassOfContainerPrintData(req);
   } catch(err){
    return this.applicationExceptionHandler.returnException(GrossMassResponseModel,err);
   }
}


// @Post('createPostShipmentDetails')
// @ApiBody({type:PostShipmentDetailsDto})
// async createPostShipmentDetails(@Body() createDto: any): Promise<CommonResponse> {
//   try {
//     return await this.service.createPostShipmentDetails(createDto);
//   } catch (error) {
//     return this.applicationExceptionHandler.returnException(CommonResponse, error)
//   }
// }







@Post('createPostShipmentDetails')
@ApiBody({type:PostShipmentDetailsDto})
async createPostShipmentDetails(@Body() createDto: any): Promise<CommonResponse> {
  try {
    return await this.service.createPostShipmentDetails(createDto);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error)
  }
}


@Post('createExpensesLogistics')
@ApiBody({type:ExpensesLogisticsDto})
async createExpensesLogistics(@Body() createDto: any): Promise<CommonResponse> {
  try {
    return await this.service.createExpensesLogistics(createDto);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error)
  }
}

@Post('/getExpensesDetailsOfLogistics')
async getExpensesDetailsOfLogistics(): Promise<CommonResponse>{
       try{
    return this.service.getExpensesDetailsOfLogistics();
   } catch(err){
    return this.applicationExceptionHandler.returnException(CommonResponse,err);
   }
}

@Post('/updateExpensesLogistics')
@ApiBody({ type: ExpensesLogisticsDto })
async updateExpensesLogistics(@Body() expensesLogisticsDto: any, isUpdate: boolean = false): Promise<CommonResponse> {
  try {
    return await this.service.updateExpensesLogistics(expensesLogisticsDto);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error)
  }

}
@Post('/getPostShippmentDetailsById')
async getPostShippmentDetailsById(@Body()req:saleOrderIdRequest): Promise<CommonResponse> {
  try {
    return await this.service.getPostShippmentDetailsById(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error)
  }

}

@Post('getPortOfDischargeById')
async getPortOfDischargeById(@Body() req: SaleOrderIdRequest): Promise<ShippmentDetailsResponse> {
    try {
        return this.service.getPortOfDischargeById(req);
    } catch (error) {
        return this.applicationExceptionHandler.returnException(ShippmentDetailsResponse, error);
    }
}

@Post('/getExpensesDetailsById')
async getExpensesDetailsById(@Body()req:saleOrderIdRequest): Promise<CommonResponse> {
  try {
    return await this.service.getExpensesDetailsById(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error)
  }

}
 @Post('/checkListInfo')
 async checkListInfo(@Body() req:saleOrderIdRequest):Promise<CommonResponse>{
    try{
        return await this.service.checkListInfo(req);
    }
    catch(error){
        return this.applicationExceptionHandler.returnException(CommonResponse,error);
    }
 }


 @Post('getPostShipmentDetailsLc')
 async getPostShipmentDetailsLc(@Body() req: SaleOrderIdRequestLc): Promise<CommonResponse> {
     try {
         return this.service.getPostShipmentDetailsLc(req);
     } catch (error) {
         return this.applicationExceptionHandler.returnException(CommonResponse, error);
     }
 }

 @Post('getVesselDetailsForPostShipment')
 async getVesselDetailsForPostShipment(@Body() req?:SaleOrderIdRequestLc):Promise<CommonResponse>{
    try{
        return this.service.getVesselDetailsForPostShipment(req)
    }catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
 }
 @Post('updateAuthorised')
 async updateAuthorised(@Body() req:AuthorisedRequest):Promise<CommonResponse>{
    try{
        return this.service.updateAuthorised(req)
    }catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
 }

 @Post('getCvdRatesForCustomsInvoice')
 async getCvdRatesForCustomsInvoice(@Body() req:componentRequest):Promise<CommonResponse>{
    try{
        return this.service.getCvdRatesForCustomsInvoice(req)
    }catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
 }

  @Post('getContainerStatusCount')
 async getContainerStatusCount(@Body() req?:UnitRequest):Promise<CommonResponse>{
    try{
        return this.service.getContainerStatusCount(req)
    }catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
 }

   @Post('getSpsaPackingPrint')
 async getSpsaPackingPrint(@Body() req?:SaleOrderIdRequest):Promise<CommonResponse>{
    try{
        return this.service.getSpsaPackingPrint(req)
    }catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
 }
}
